/*
 * Access redux store outside component or action creator
 */
const GlobalReduxStore = (() => {
  let rdxStore;

  function setStore(store) {
    if (!rdxStore) rdxStore = store;
  }

  function getStore() {
    return rdxStore;
  }

  function getState() {
    return rdxStore.getState();
  }

  return {
    setStore,
    getStore,
    getState,
  };
})();

export default GlobalReduxStore;
